import React from "react";
import calcScrollBarWidth from "./calcScrollBarWidth";

export type CompensateScrollDecoration = {
  style: {
    paddingRight: React.CSSProperties["paddingRight"];
  };
  className: string;
};

export const OVERFLOW_HIDDEN_CLASS = "frozen";

/** Returns a list of style and css properties for scroll decoration */
/** Provided not as raw body changes as some SSR frameworks allow to pass data to the `document` / `body` elements */
const compensateScrollDecoration = (
  state: boolean,
  element: HTMLElement = document.body,
): CompensateScrollDecoration => ({
  style: {
    paddingRight: state ? `${calcScrollBarWidth(element)}px` : null,
  },
  className: state ? OVERFLOW_HIDDEN_CLASS : "",
});

export default compensateScrollDecoration;
